import type { ExperienceActionDto } from "@intelligems/ig-types/dtos/experience-actions";

export const actionTsDescSort = (
  a: ExperienceActionDto,
  b: ExperienceActionDto
): number => {
  if (a.actionTs < b.actionTs) {
    return 1;
  }
  if (a.actionTs > b.actionTs) {
    return -1;
  }
  if (a.action === "reset" && b.action !== "reset") {
    return -1;
  }
  if (a.action !== "reset" && b.action === "reset") {
    return 1;
  }
  return 0;
};

export const actionTsAscSort = (
  a: ExperienceActionDto,
  b: ExperienceActionDto
): number => {
  if (a.actionTs > b.actionTs) {
    return 1;
  }
  if (a.actionTs < b.actionTs) {
    return -1;
  }
  return 0;
};

export const getStartedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);
  const latestReset = sortedActions.find((action) => action.action === "reset");

  if (latestReset) {
    return (
      sortedActions.find(
        (action) =>
          action.action === "start" && action.actionTs > latestReset.actionTs
      ) || null
    );
  }

  return sortedActions.find((action) => action.action === "start") || null;
};

export const getPausedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);

  if (sortedActions[0].action === "pause") {
    return sortedActions[0];
  }
  return null;
};

export const getEndedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);

  if (sortedActions[0].action === "end") {
    return sortedActions[0];
  }
  return null;
};

export const getFirstStartedAtTs = (
  experienceActions: ExperienceActionDto[]
) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsAscSort);
  const resetActions = sortedActions.filter(
    (action) => action.action === "reset"
  );
  const latestReset = resetActions.length
    ? resetActions[resetActions.length - 1]
    : null;

  const startActions = sortedActions.filter(
    (action) =>
      action.action === "start" &&
      (!latestReset || action.actionTs > latestReset.actionTs)
  );

  return startActions.length ? startActions[0].actionTs : null;
};

export const getLastEndedAtTs = (experienceActions: ExperienceActionDto[]) => {
  const sortedActions = [...experienceActions].sort(
    (a, b) => a.actionTs - b.actionTs
  );
  const found = sortedActions.find((action) => action.action === "end");
  return found ? found.actionTs : null;
};

export const getExperienceActionSpans = (
  experienceActions: ExperienceActionDto[],
  placeholderEndTs: number
) => {
  const sortedEvents = [...experienceActions].sort(
    (a, b) => a.actionTs - b.actionTs
  );

  const intervals: { start_ts: number; end_ts: number }[] = [];

  for (let i = 0; i < sortedEvents.length; i++) {
    const event = sortedEvents[i];

    if (event.action !== "start") {
      continue;
    }

    const nextEvent = sortedEvents
      .slice(i + 1)
      .find(
        (candidate) =>
          candidate.action === "pause" || candidate.action === "end"
      );

    intervals.push({
      start_ts: Math.floor(event.actionTs / 1000),
      end_ts: nextEvent
        ? Math.floor(nextEvent.actionTs / 1000)
        : placeholderEndTs,
    });
  }

  return intervals;
};
